import type { Action } from 'redesign/components/organisms/action-wrapper/types'
import type { TaskTypeT } from 'shared/constants'
import { TASK_TYPES } from '../../ContentLists/TaskList/constants'
import { getAbsenceRequestActionButtons } from '../../absence-request-details/utils/get-absence-request-action-buttons'
import { getMonthlySheetActionButtons } from '../../monthly-sheet-details/utils/get-monthly-sheet-action-buttons'
import { getSecureConnectionActionButtons } from '../../secure-connection-details/utils/get-secure-connection-action-buttons'
import { getSharedUserDataActionButtons } from '../../share-user-data/utils/get-shared-user-data-action-buttons'
import { EMPTY_ACTIONS } from '../constants'
import type { ResolveActionButtonsProps } from '../types'
import { getMainAndHiddenButtons } from './get-main-and-hidden-buttons'

const strategyMap: Record<TaskTypeT, (props: ResolveActionButtonsProps) => Action[]> = {
  [TASK_TYPES.monthlySheet]: (props: ResolveActionButtonsProps) => getMonthlySheetActionButtons(props),
  [TASK_TYPES.absenceRequest]: (props: ResolveActionButtonsProps) => getAbsenceRequestActionButtons(props),
  [TASK_TYPES.shareUserData]: (props: ResolveActionButtonsProps) => getSharedUserDataActionButtons(props),
  [TASK_TYPES.shiftUpdate]: () => [],
  [TASK_TYPES.secureConnection]: (props: ResolveActionButtonsProps) => getSecureConnectionActionButtons(props),
} as const

export const resolveActionButtons = (props: ResolveActionButtonsProps) => {
  if (!props.task.taskType) return EMPTY_ACTIONS

  const strategy = strategyMap[props.task.taskType as TaskTypeT]

  if (!strategy) return EMPTY_ACTIONS

  return getMainAndHiddenButtons(strategy(props))
}
